import Treatments from './constants';
import EnterpriseFeaturesGp69 from '~pricing/experiments/EnterpriseFeaturesGp69';
import Grow2427SocialProof from '~app/pages/Pricing/experiments/grow_2427_social_proof';
import DiscountBanner from '~pricing/components/DiscountBanner';
import AdaChatBot from '~app/pages/Pricing/experiments/GROW2911AdaChatbot';

const ACTIVE_TREATMENTS = {
  [Treatments.ENTERPRISE_FEATURES_GP69]: {
    configExperimentIdentifier: 'ENTERPRISE_FEATURES_GP69',
    experimentComponent: EnterpriseFeaturesGp69,
  },
  [Treatments.GROW_2427_TREATMENT]: {
    configExperimentIdentifier: 'GROW_2427_TREATMENT',
    experimentComponent: Grow2427SocialProof,
  },
  [Treatments.BILLING_20014_T1]: {
    configExperimentIdentifier: 'BILLING_20014_T1',
    experimentComponent: DiscountBanner,
  },
  [Treatments.GROW_2911_TREATMENT]: {
    configExperimentIdentifier: 'GROW_2911_TREATMENT',
    experimentComponent: AdaChatBot,
  },
} as const; // readonly

export default ACTIVE_TREATMENTS;
